import { render, staticRenderFns } from "./daqi-copyright.vue?vue&type=template&id=2d57e3df&scoped=true&"
import script from "./daqi-copyright.vue?vue&type=script&lang=js&"
export * from "./daqi-copyright.vue?vue&type=script&lang=js&"
import style0 from "./daqi-copyright.vue?vue&type=style&index=0&id=2d57e3df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d57e3df",
  null
  
)

export default component.exports